import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import './styles/fonts.css';

const StandingWidget = Loadable({
  loader: () => import('./containers/StandingWidget/index'),
  loading() {
    return <div />;
  },
});

const StandingDashedWidget = Loadable({
  loader: () => import('./containers/StandingDashedWidget/index'),
  loading() {
    return <div />;
  },
});

const TopScorersWidget = Loadable({
  loader: () => import('./containers/TopScorersWidget/index'),
  loading() {
    return <div />;
  },
});

const StandingStripWidget = Loadable({
  loader: () => import('./containers/StandingStripWidget/index'),
  loading() {
    return <div />;
  },
});

const MatchWidget = Loadable({
  loader: () => import('./containers/MatchWidget/index'),
  loading() {
    return <div />;
  },
});

const MatchStripWidget = Loadable({
  loader: () => import('./containers/MatchStripWidget/index'),
  loading() {
    return <div />;
  },
});

const DayStripWidget = Loadable({
  loader: () => import('./containers/DayStripWidget/index'),
  loading() {
    return <div />;
  },
});

const DayWidget = Loadable({
  loader: () => import('./containers/DayWidget/index'),
  loading() {
    return <div />;
  },
});

const LeafEventWidget = Loadable({
  loader: () => import('./containers/LeafEventWidget/index'),
  loading() {
    return <div />;
  },
});

const LeafCompetitionWidget = Loadable({
  loader: () => import('./containers/LeafCompetitionWidget/index'),
  loading() {
    return <div />;
  },
});

const NextMatchWidget = Loadable({
  loader: () => import('./containers/NextMatchWidget/index'),
  loading() {
    return <div />;
  },
});

const NextRaceWidget = Loadable({
  loader: () => import('./containers/NextRaceWidget/index'),
  loading() {
    return <div />;
  },
});

const MatchLineUpsWidget = Loadable({
  loader: () => import('./containers/MatchLineUpsWidget/index'),
  loading() {
    return <div />;
  },
});

const WorldCupWidget = Loadable({
  loader: () => import('./containers/WorldCupWidget/index'),
  loading() {
    return <div />;
  },
});

const WorldCupCalendarWidget = Loadable({
  loader: () => import('./containers/WorldCupCalendarWidget/index'),
  loading() {
    return <div />;
  },
});

const UefaCalendarWidget = Loadable({
  loader: () => import('./containers/UefaCalendarWidget/index'),
  loading() {
    return <div />;
  },
});

const CalendarCorriereWidget = Loadable({
  loader: () => import('./containers/CalendarCorriereWidget/index'),
  loading() {
    return <div />;
  },
});

const CupCalendarCorriereWidget = Loadable({
  loader: () => import('./containers/CupCalendarCorriereWidget/index'),
  loading() {
    return <div />;
  },
});

const FootballSectionWidget = Loadable({
  loader: () => import('./containers/FootballSectionWidget/index'),
  loading() {
    return <div />;
  },
});

const LeafMatchesWidget = Loadable({
  loader: () => import('./containers/LeafMatchesWidget/index'),
  loading() {
    return <div />;
  },
});

const TeamCalendarWidget = Loadable({
  loader: () => import('./containers/TeamCalendarWidget/index'),
  loading() {
    return <div />;
  },
});

const SquadWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/SquadWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const TopScorersWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/TopScorersWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const StandingWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/StandingWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const DayWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/DayWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const ReportWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/ReportWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const CalendarWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/CalendarWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const CupCalendarWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/CupCalendarWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const TeamCalendarWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/TeamCalendarWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const TeamCalendarFullWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/TeamCalendarFullWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const MatchWidgetGazzanet = Loadable({
  loader: () => import('./containers/GazzanetWidgets/MatchWidgetGazzanet/index'),
  loading() {
    return <div />;
  },
});

const RaceStandingsWidget = Loadable({
  loader: () => import('./containers/RaceStandingsWidget/index'),
  loading() {
    return <div />;
  },
});

const CalendarWidget = Loadable({
  loader: () => import('./containers/CalendarWidget/index'),
  loading() {
    return <div />;
  },
});

const OptaWidgets = Loadable({
  loader: () => import('./containers/OptaWidgets/index'),
  loading() {
    return <div />;
  },
});

export default class App extends Component {
  render() {
    const { widgetConfigs } = this.props;
    const widgetMap = {
      //Rugby Compatible
      StandingWidget: <StandingWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      //Rugby Compatible
      StandingDashedWidget: <StandingDashedWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      TopScorersWidget: <TopScorersWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      //Rugby Compatible
      StandingStripWidget: <StandingStripWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      MatchWidget: <MatchWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
        widgetId={widgetConfigs.widgetId}
      />,
      MatchStripWidget: <MatchStripWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
        fullView={widgetConfigs.fullView}
        widgetId={widgetConfigs.widgetId}
      />,
      //Rugby Compatible
      DayStripWidget: <DayStripWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
        day={widgetConfigs.day}
      />,
      //Rugby Compatible
      DayWidget: <DayWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
        day={widgetConfigs.day}
      />,
      LeafEventWidget: <LeafEventWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
        pulseLive={widgetConfigs.pulseLive}
        noFavStar={widgetConfigs.noFavStar}
        noLogo={widgetConfigs.noLogo}
        newspaper={widgetConfigs.newspaper}
        widgetId={widgetConfigs.widgetId}
      />,
      //Multi widgets compatibile
      LeafCompetitionWidget: <LeafCompetitionWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        oldestFirst={widgetConfigs.oldestFirst}
        pulseLive={widgetConfigs.pulseLive}
        noFavStar={widgetConfigs.noFavStar}
        noLogo={widgetConfigs.noLogo}
        newspaper={widgetConfigs.newspaper}
        widgetId={widgetConfigs.widgetId}
      />,
      NextMatchWidget: <NextMatchWidget
        sportId={widgetConfigs.sportId}
        teamId={widgetConfigs.teamId}
        widgetId={widgetConfigs.widgetId}
      />,
      NextRaceWidget: <NextRaceWidget
        sportId={widgetConfigs.sportId}
        competitionId={widgetConfigs.competitionId}
        widgetId={widgetConfigs.widgetId}
      />,
      MatchLineUpsWidget: <MatchLineUpsWidget
        sportId={widgetConfigs.sportId}
        competitionId={widgetConfigs.competitionId}
        hometeam={widgetConfigs.hometeam}
        awayteam={widgetConfigs.awayteam}
        widgetId={widgetConfigs.widgetId}
      />,
      //TODO da migrare al multi widget NON tornano dati dal BE
      WorldCupWidget: <WorldCupWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        oldestFirst={widgetConfigs.oldestFirst}
      />,
      WorldCupCalendarWidget: <WorldCupCalendarWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      UefaCalendarWidget: <UefaCalendarWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      //TODO da migrare al multi widget
      CalendarCorriereWidget: <CalendarCorriereWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        day={widgetConfigs.day}
      />,
      //TODO da migrare al multi widget
      CupCalendarCorriereWidget: <CupCalendarCorriereWidget
        competitionId={widgetConfigs.competitionId}
        widgetId={widgetConfigs.widgetId}
        sportId={widgetConfigs.sportId}
        seasonId={widgetConfigs.seasonId}
        phase={widgetConfigs.phase}
        subphase={widgetConfigs.subphase}
      />,
      //Rugby Compatible
      FootballSectionWidget: <FootballSectionWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        isMainSection={widgetConfigs.isMainSection}
        widgetId={widgetConfigs.widgetId}
      />,
      //Multi widgets compatibile
      LeafMatchesWidget: <LeafMatchesWidget
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        oldestFirst={widgetConfigs.oldestFirst}
        pulseLive={widgetConfigs.pulseLive}
        noFavStar={widgetConfigs.noFavStar}
        noLogo={widgetConfigs.noLogo}
        newspaper={widgetConfigs.newspaper}
        matches={widgetConfigs.matches}
        widgetId={widgetConfigs.widgetId}
      />,
      TeamCalendarWidget: <TeamCalendarWidget
        sportId={widgetConfigs.sportId}
        teamId={widgetConfigs.teamId}
        seasonId={widgetConfigs.seasonId}
        widgetTitle={widgetConfigs.widgetTitle}
        widgetId={widgetConfigs.widgetId}
      />,
      SquadWidgetGazzanet: <SquadWidgetGazzanet
        sportId={widgetConfigs.sportId}
        teamId={widgetConfigs.teamId}
        competitionId={widgetConfigs.competitionId}
        widgetId={widgetConfigs.widgetId}
      />,
      TopScorersWidgetGazzanet: <TopScorersWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      StandingWidgetGazzanet: <StandingWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      DayWidgetGazzanet: <DayWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
        day={widgetConfigs.day}
      />,
      ReportWidgetGazzanet: <ReportWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
        widgetId={widgetConfigs.widgetId}
      />,
      //TODO da migrare al multi widget
      CalendarWidgetGazzanet: <CalendarWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
      />,
      //TODO da migrare al multi widget
      CupCalendarWidgetGazzanet: <CupCalendarWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
      />,
      TeamCalendarWidgetGazzanet: <TeamCalendarWidgetGazzanet
        sportId={widgetConfigs.sportId}
        teamId={widgetConfigs.teamId}
        seasonId={widgetConfigs.seasonId}
        widgetId={widgetConfigs.widgetId}
        competitionId={widgetConfigs.competitionId}
      />,
      TeamCalendarFullWidgetGazzanet: <TeamCalendarFullWidgetGazzanet
        sportId={widgetConfigs.sportId}
        teamId={widgetConfigs.teamId}
        seasonId={widgetConfigs.seasonId}
        widgetId={widgetConfigs.widgetId}
        competitionId={widgetConfigs.competitionId}
      />,
      MatchWidgetGazzanet: <MatchWidgetGazzanet
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        matchId={widgetConfigs.matchId}
        widgetId={widgetConfigs.widgetId}
      />,
      RaceStandingsWidget: <RaceStandingsWidget
        widgetConfigs={widgetConfigs}
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
      />,
      CalendarWidget: <CalendarWidget
        widgetConfigs={widgetConfigs}
        competitionId={widgetConfigs.competitionId}
        sportId={widgetConfigs.sportId}
        widgetId={widgetConfigs.widgetId}
        newspaper={widgetConfigs.newspaper}
      />,
      OptaWidgets: <OptaWidgets
        widgetConfigs={widgetConfigs}
        widgetId={widgetConfigs.widgetId}
        optaType={widgetConfigs.optaType}
        newspaper={widgetConfigs.newspaper}
      />,
    };
    return widgetMap[widgetConfigs.widgetType];
  }
}

App.propTypes = {
  widgetConfigs: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/App.js